module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "dabef9d1bfb79-d1e394"
    }
  }, [_c('span', {
    attrs: {
      "id": "pageix"
    }
  }, [_c('p', {
    staticClass: "prelims-epigraph-first"
  }, [_vm._v("‘The legacy of heroes is the memory of a great name and the inheritance of a great example.’")]), _vm._v(" "), _c('p', {
    staticClass: "prelims-epigraph-source-space-after"
  }, [_vm._v("Benjamin Disraeli")]), _vm._v(" "), _c('p', {
    staticClass: "prelims-epigraph"
  }, [_vm._v("To the one who has gone before, the great master of horseracing novels, Dick Francis, thank you for all those wonderful reads. I offer my sincere gratitude and humbly follow in your footsteps.")]), _vm._v(" "), _c('p', {
    staticClass: "prelims-epigraph-source"
  }, [_vm._v("Glenis Wilson")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b162aa0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781780106403_epub_epi.vue
// module id = 78
// module chunks = 0